module.exports = __webpack_public_path__ + "public/img/junelight-Googleplaystore-DE_original.aad81448.png";